type NativeBridgeWindow = {
    ReactNativeWebView?: {
        postMessage?: (message: string) => void
    }
}

export function postMessageToNative(
    message: string,
    targetWindow: NativeBridgeWindow | undefined = typeof window === 'undefined'
        ? undefined
        : window,
    onError?: (error: unknown) => void,
): boolean {
    const nativeBridge = targetWindow?.ReactNativeWebView
    if (typeof nativeBridge?.postMessage !== 'function') return false

    try {
        nativeBridge.postMessage(message)
        return true
    } catch (error) {
        onError?.(error)
        return false
    }
}
